module.exports = "/assets/data/e19784abb45b7b3db1d929870401fa9f-SW2.data.json";